import { ButtonHTMLAttributes, FC, ReactNode } from "react";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

interface ActionButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "light" | "dark";
  children: ReactNode;
  className?: string;
  showIcon?: boolean;
}

const ActionButton: FC<ActionButtonProps> = ({
  variant = "light",
  children,
  className,
  showIcon = true,
  ...props
}) => {
  const baseStyles =
    "flex items-center justify-center gap-2.5 rounded-full px-6 py-3.5 text-base font-medium transition-colors md:px-8 md:py-4 shrink-0";

  const variants = {
    light: "bg-white text-dark hover:bg-white/90",
    dark: "bg-dark text-white hover:bg-dark/90",
  };

  return (
    <button className={cn(baseStyles, variants[variant], className)} {...props}>
      {children}
      {showIcon && <ArrowRight size={18} />}
    </button>
  );
};

export default ActionButton;
